module.exports = __webpack_public_path__ + "static/assets/209cd016f099f4515cf80dff81e6e0f7.svg";